import { RadioButton, styled, RadioGroup, TextField, CustomTextFieldProps } from "@tm/components"
import { forwardRef } from "react"

export const RadioButtonSmallWithMargin = styled(RadioButton)({
    marginRight: ".5em",
})
RadioButtonSmallWithMargin.defaultProps = { size: "medium" }

export const RadioGroupGrid = styled(RadioGroup, {
    shouldForwardProp: (prop) => prop !== "rowcap" && prop !== "minwidth",
})<{ rowcap?: string; minwidth?: string }>(({ rowcap, minwidth }) => ({
    display: "grid",
    gridTemplateColumns: `minmax(${minwidth || "50px"}, auto) 1fr`,
    columnGap: "26px",
    rowGap: rowcap || "4px",
}))

export const OrderOptionTextField = forwardRef<HTMLDivElement, CustomTextFieldProps>((props, ref) => (
    <TextField {...props} size="extralarge" clearButton ref={ref} />
))
